import { animate, group, keyframes, query, style, transition, trigger } from '@angular/animations';

export const carouselSlideTimings = '300ms ease-in-out';

export const carouselSlideAnimation = trigger('slideAnimation', [
  transition('void => *, no-animation => *', []),
  transition('* => *', [
    style({ position: 'relative', overflow: 'hidden' }),
    group([
      query(
        '.carousel-slide--previous',
        style({
          position: 'absolute',
          top: '0',
          left: '0',
          width: 'auto',
          height: 'auto',
        }),
        { optional: true }
      ),

      // if selected is slide `i` and previous is `i+1`, [] => X => []
      query(
        `.carousel-slide--selected + .carousel-slide--previous`,
        animate(
          carouselSlideTimings,
          keyframes([
            style({ transform: `translateX(0)`, opacity: 1 }),
            style({ transform: `translateX(50%)`, opacity: 0 }),
            style({ transform: `translateX(100%)`, opacity: 0 }),
          ])
        ),
        { optional: true }
      ),
      query(
        `:not(.carousel-slide--previous) + .carousel-slide--selected, .carousel-slide--selected:first-child`,
        animate(
          carouselSlideTimings,
          keyframes([
            style({ transform: `translateX(-100%)`, opacity: 0 }),
            style({ transform: `translateX(-50%)`, opacity: 1 }),
            style({ transform: `translateX(0)`, opacity: 1 }),
          ])
        ),
        { optional: true }
      ),

      // if selected is slide `i` and previous is `i-1`, [] <= X <= []
      query(
        `.carousel-slide--previous + .carousel-slide--selected`,
        animate(
          carouselSlideTimings,
          keyframes([
            style({ transform: `translateX(100%)`, opacity: 0 }),
            style({ transform: `translateX(50%)`, opacity: 1 }),
            style({ transform: `translateX(0)`, opacity: 1 }),
          ])
        ),
        { optional: true }
      ),
      query(
        `:not(.carousel-slide--selected) + .carousel-slide--previous, .carousel-slide--previous:first-child`,
        animate(
          carouselSlideTimings,
          keyframes([
            style({ transform: `translateX(0)`, opacity: 1 }),
            style({ transform: `translateX(-50%)`, opacity: 0 }),
            style({ transform: `translateX(-100%)`, opacity: 0 }),
          ])
        ),
        { optional: true }
      ),
    ]),
  ]),
]);
